<script setup lang="ts">
</script>

<template>
  <UCard>
    <template #header>
      <CardHeader>Velkommen</CardHeader>
    </template>

    <CurrentRoundMessage />

    <template #footer>
      <UButton
        to="/submit"
        variant="outline"
      >
        Indsend gæt her
      </UButton>
      <p class="text-zinc-500">
        *kræver Discord login
      </p>
    </template>
  </UCard>
</template>
